module.exports = __webpack_public_path__ + "static/logo-e536030bff690168b4aa4a6c7fe416af.png";